import type { ReactNode } from 'react';

export const OneColumn = ({ children }: { children: ReactNode }) => (
  <div className="relative w-full max-w-screen-xl text-solid lg:p-x3 lg:pt-x1">
    {children}
  </div>
);
